import React, { useState } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useLocation } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { useSelector } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import CollectionSettlementList from "../Bill/CollectionSettlementList"
import CollectionPaymentList from "../Bill/CollectionPaymentList"

const SettlementManagementDetails = () => {
  const selector = useSelector(state => state)
  const location = useLocation()

  const [type, setType] = useState(selector.auth.user?.type || "")
  const [detailType, setDetailType] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]?.type || "")
  const [collectionState, setCollectionState] = useState('collection')
  // 드롭다운
  const [settingMenu, setSettingMenu] = useState(false)
  const [settingMenu2, setSettingMenu2] = useState(false)
  const [settlementState, setSettlementState] = useState('settlement')
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);
  const [myCompany, setMyCompany] = useState(location?.state)

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>정산관리 상세 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" title="정산관리" breadcrumbItem="정산관리 상세" />
          <Row>
            <Col sm={12}>
              <div className="float-start btn-group mb-4" style={{ height: 38 }}>
                <Button
                  type="button"
                  size="sm"
                  className={settlementState === 'settlement' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                  onClick={() => {
                    setSettlementState('settlement')
                  }}
                >
                  정산내역
                </Button>
                <Button
                  type="button"
                  size="sm"
                  className={settlementState === 'payment' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                  onClick={() => {
                    setSettlementState('payment')
                  }}
                >
                  고지내역
                </Button>
              </div>
            </Col>
          </Row>

          {settlementState === 'settlement' && <CollectionSettlementList />}
          {settlementState === 'payment' && <CollectionPaymentList />}

        </Container>
      </div>
    </React.Fragment>
  )
}

export default SettlementManagementDetails
